/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Request body for CLI login with explicit tenant id or slug.
 */
export interface CliLoginRequest {
  tenant: string;
  username: string;
  password: string;
}
